// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"8e4a2314","513":"24725f5e","703":"2ce2ac85"}[chunkId] + ".chunk.js";
};